import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import CircularLoading from "../components/CircularLoading";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable, { MTableToolbar } from "material-table";
import "./../assets/stilos.css";
import {
  Grid,
  IconButton,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { useTranslation } from "react-i18next";
import AlertDialog from "../components/AlertDialog";
import {
  ReferralsColumns,
} from "../common/sharedFunctions";
import { api } from 'common';
import { useSelector, useDispatch } from "react-redux";
import driverBanner from "../assets/img/driver2.jpg";

const FONT = "'Outfit', 'Poppins', sans-serif";

const BookingHistory = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const dispatch = useDispatch();
  const location = useLocation();
  
  // Selectores con valores por defecto seguros
  const auth = useSelector((state) => state?.auth || {});
  const settings = useSelector((state) => state?.settingsdata?.settings || {});
  const bookinglistdata = useSelector((state) => state?.bookinglistdata || { loading: false });
  const listlv1 = useSelector((state) => state?.usedreferralid || {
    listRefer: null,
    listRefer2: null,
    listRefer3: null,
    elsposor: null
  });
  
  const role = auth?.profile?.usertype || null;
  const sponsi = listlv1?.elsposor || "";
  
  const [data, setData] = useState([]);
  const [enrichedData, setEnrichedData] = useState([]);
  const [level, setLevel] = useState("");
  const [nivel, setNivel] = useState(1);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [selectedRow, setSelectedRow] = useState(null);

  // Funciones necesarias (acceder directamente ya que son estables)
  const listReferral = api.listReferral;
  const clearReferralSubLevels = api.clearReferralSubLevels;
  const fetchSponsorName = api.fetchSponsorName;
  const clearSponsorDisplay = api.clearSponsorDisplay;
  const normalizeSponsorUid = api.normalizeSponsorUid;
  const batchFetchSponsorNames = api.batchFetchSponsorNames;
  const isPlatformMasterReferrerSignup = api.isPlatformMasterReferrerSignup;
  const listReferral2 = api.listReferral2;
  const listReferral3 = api.listReferral3;
  const lista_id = api.lista_id;
  const lista_id2 = api.lista_id2;
  const getUserReferralsLevel2 = api.getUserReferralsLevel2;
  const getUserReferralsLevel3 = api.getUserReferralsLevel3;
  const getAggregatedReferralsLevel2 = api.getAggregatedReferralsLevel2;
  const loadAggregatedReferralsLevel3 = api.loadAggregatedReferralsLevel3;

  // Definir columns solo cuando tenemos los datos necesarios
  let columns = [];
  if (role && settings && Object.keys(settings).length > 0) {
    try {
      columns = ReferralsColumns(role, settings, t, isRTL);
    } catch (error) {
      console.error("Error creating columns:", error);
      columns = [];
    }
  }
 




  /**
   * Level 1: solo lista principal; limpia caché L2/L3 para no mezclar con un drill anterior.
   * Level 2 / 3: cargan siempre el árbol completo de ese nivel (agregado de todos los padres del nivel anterior).
   * Antes solo se rellenaba L2/L3 al hacer clic en una fila porque Redux quedaba en null tras refrescar.
   */
  const btn_level = (valor) => {
    switch (valor) {
      case 1:
        setLevel("Level 1");
        setNivel(1);
        dispatch(clearReferralSubLevels());
        if (listlv1?.listRefer?.length) {
          setData(listlv1.listRefer);
        } else {
          setData([]);
        }
        break;
      case 2: {
        setLevel("Level 2");
        setNivel(2);
        setData([]);
        const l1 = listlv1?.listRefer;
        if (l1?.length) {
          dispatch(getAggregatedReferralsLevel2(l1.map((r) => r.id)));
        }
        break;
      }
      case 3: {
        setLevel("Level 3");
        setNivel(3);
        setData([]);
        dispatch(loadAggregatedReferralsLevel3());
        break;
      }
      default:
        break;
    }
  };

   const lista_referral = (value) => {
    // value puede ser selectedRow (objeto) o selectedRow.id (uid) según MaterialTable
    const uid = value && typeof value === 'object' ? value.id : value;
    if (!uid) return;

    switch (nivel) {
      case 1:
        setData([]); // Limpiar mientras carga
        setNivel(2);
        setLevel("Level 2");
        dispatch(lista_id(uid));
        dispatch(getUserReferralsLevel2(uid));
        break;
      case 2:
        setData([]); // Limpiar mientras carga
        setNivel(3);
        setLevel("Level 3");
        dispatch(lista_id2(uid));
        dispatch(getUserReferralsLevel3(uid));
        break;
      default:
        return;
    }
   }

  const refreshReferralList = useCallback(() => {
    const id_cli = auth?.profile?.uid;
    if (!id_cli) return;
    setData([]);
    setLevel("Level 1");
    setNivel(1);
    dispatch(clearReferralSubLevels());
    // forceRefresh: vuelve a pedir la lista (evita lista obsoleta al volver a la pantalla)
    dispatch(listReferral(id_cli, true));
  }, [auth?.profile?.uid, dispatch, listReferral, clearReferralSubLevels]);

useEffect(() => {
  if (!auth?.profile?.uid || location.pathname !== "/myreferrals") return;
  refreshReferralList();
  if (isPlatformMasterReferrerSignup(auth.profile.signupViaReferral)) {
    dispatch(clearSponsorDisplay());
  } else {
    const sponsorUid = normalizeSponsorUid(auth.profile.signupViaReferral);
    if (sponsorUid) {
      dispatch(fetchSponsorName(sponsorUid));
    } else {
      dispatch(clearSponsorDisplay());
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [auth?.profile?.uid, auth?.profile?.referralId, location.pathname]);



useEffect(() => {
  // Actualizar datos cuando cambian los listados de referidos
  if (nivel === 1 && listlv1?.listRefer) {
    setData(listlv1.listRefer);
    setLevel("Level 1");
  } else if (nivel === 2 && listlv1?.listRefer2) {
    setData(listlv1.listRefer2);
    setLevel("Level 2");
  } else if (nivel === 3 && listlv1?.listRefer3) {
    setData(listlv1.listRefer3);
    setLevel("Level 3");
  }
}, [nivel, listlv1?.listRefer, listlv1?.listRefer2, listlv1?.listRefer3]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!data || !Array.isArray(data) || data.length === 0) {
        setEnrichedData([]);
        return;
      }
      try {
        const nameMap = await batchFetchSponsorNames(data.map((r) => r.signupViaReferral));
        if (cancelled) return;
        const masterLabel = t("codigo_master");
        setEnrichedData(
          data.map((row) => {
            const sid = normalizeSponsorUid(row.signupViaReferral);
            const sponsorDisplay =
              isPlatformMasterReferrerSignup(row.signupViaReferral) || !sid
                ? masterLabel
                : nameMap[sid] || masterLabel;
            const net = api.normalizeNetworkState
              ? api.normalizeNetworkState(row, row.id)
              : { inNetwork: false };
            const networkLevelLabel = net.inNetwork
              ? api.networkLevelLabel(net.level)
              : row.signupMode === "city_special"
                ? api.networkLevelLabel(0)
                : "—";
            const directSlotsLabel = net.inNetwork
              ? api.formatDirectSlots(net.used, net.total)
              : "—";
            return {
              ...row,
              sponsorDisplay,
              networkLevelLabel,
              directSlotsLabel,
            };
          })
        );
      } catch (e) {
        if (!cancelled) {
          const masterLabel = t("codigo_master");
          setEnrichedData(
            data.map((row) => ({
              ...row,
              sponsorDisplay:
                isPlatformMasterReferrerSignup(row.signupViaReferral) ||
                !normalizeSponsorUid(row.signupViaReferral)
                  ? masterLabel
                  : row.signupViaReferral,
            }))
          );
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [data, t, batchFetchSponsorNames, normalizeSponsorUid, isPlatformMasterReferrerSignup]);






const handleCommonAlertClose = (e) => {
  e.preventDefault();
  setCommonAlert({ open: false, msg: "" });
};



  // Mostrar loading mientras se cargan los datos necesarios
  if (!auth?.profile || !role || !settings || Object.keys(settings).length === 0) {
    return <CircularLoading />;
  }

  const sponsorUidHeader = normalizeSponsorUid(auth?.profile?.signupViaReferral);
  const sponsorHeaderDisplay = isPlatformMasterReferrerSignup(auth?.profile?.signupViaReferral)
    ? t("codigo_master")
    : sponsorUidHeader
      ? (String(sponsi || "").trim() ? sponsi : "…")
      : t("codigo_master");

  /** Contadores por nivel (L2/L3: null = aún no cargados en Redux tras refresco o sin visitar el nivel) */
  const referralCountL1 = Array.isArray(listlv1?.listRefer) ? listlv1.listRefer.length : 0;
  const referralCountL2 =
    listlv1?.listRefer2 == null
      ? null
      : Array.isArray(listlv1.listRefer2)
        ? listlv1.listRefer2.length
        : 0;
  const referralCountL3 =
    listlv1?.listRefer3 == null
      ? null
      : Array.isArray(listlv1.listRefer3)
        ? listlv1.listRefer3.length
        : 0;

  const referralCountBadge = (count) =>
    count === null
      ? t("referrals_not_loaded_abbr", { defaultValue: "—" })
      : String(count);

  const myNetwork = api.normalizeNetworkState
    ? api.normalizeNetworkState(auth.profile, auth.profile?.uid)
    : { inNetwork: false };
  const mySlotsUsed =
    auth.profile?.directSlotsUsed != null
      ? Number(auth.profile.directSlotsUsed) || 0
      : myNetwork.inNetwork
        ? referralCountL1
        : 0;
  const mySlotsTotal = myNetwork.inNetwork
    ? myNetwork.total
    : auth.profile?.signupMode === "city_special"
      ? api.DIRECT_SLOTS_PER_LEVEL || 50
      : null;
  const myLevelLabel = myNetwork.inNetwork
    ? api.networkLevelLabel(myNetwork.level)
    : auth.profile?.signupMode === "city_special"
      ? api.networkLevelLabel(0)
      : null;

  const levelCards = [
    {
      n: 1,
      label: t("referral_level_1", { defaultValue: "LEVEL 1" }),
      count: referralCountL1,
      hint: t("referral_level_1_hint", { defaultValue: "Referidos directos (nivel 1)" }),
      active: nivel === 1,
    },
    {
      n: 2,
      label: t("referral_level_2", { defaultValue: "LEVEL 2" }),
      count: referralCountL2,
      hint: t("referral_level_2_hint", {
        defaultValue: "Total nivel 2 (pulsa para cargar). «—» = aún no cargado.",
      }),
      active: nivel === 2,
    },
    {
      n: 3,
      label: t("referral_level_3", { defaultValue: "LEVEL 3" }),
      count: referralCountL3,
      hint: t("referral_level_3_hint", {
        defaultValue: "Total nivel 3 (pulsa para cargar). «—» = aún no cargado.",
      }),
      active: nivel === 3,
    },
  ];

  const copySponsor = async () => {
    try {
      await navigator.clipboard.writeText(String(sponsorHeaderDisplay || ""));
      setCommonAlert({
        open: true,
        msg: t("link_copied", { defaultValue: "Copiado al portapapeles" }),
      });
    } catch (e) {
      /* ignore */
    }
  };

  const tableOptions = {
    pageSize: 10,
    pageSizeOptions: [10, 15, 20],
    toolbarButtonAlignment: "right",
    searchFieldAlignment: "right",
    showTitle: false,
    searchFieldStyle: {
      borderRadius: 10,
      border: "1px solid #D7CFEB",
      padding: "2px 8px",
      fontFamily: FONT,
      backgroundColor: "#FBFAFE",
    },
    exportCsv: (columns, data) => {
      let hArray = [];
      const headerRow = columns.map((col) => {
        if (typeof col.title === "object") {
          return col.title.props.text;
        }
        hArray.push(col.field);
        return col.title;
      });
      const dataRows = data.map(({ tableData, ...row }) => {
        row.bookingDate =
          new Date(row.bookingDate).toLocaleDateString() +
          " " +
          new Date(row.bookingDate).toLocaleTimeString();
        row.tripdate =
          new Date(row.tripdate).toLocaleDateString() +
          " " +
          new Date(row.tripdate).toLocaleTimeString();
        row.pickupAddress = row.pickupAddress?.replace(/,/g, ";");
        row.dropAddress = row.dropAddress?.replace(/,/g, ";");
        let dArr = [];
        for (let i = 0; i < hArray.length; i++) {
          dArr.push(row[hArray[i]]);
        }
        return Object.values(dArr);
      });
      const delimiter = ",";
      const csvContent = [headerRow, ...dataRows]
        .map((e) => (Array.isArray(e) ? e.join(delimiter) : String(e)))
        .join("\n");
      downloadCsv(csvContent, "download.csv");
    },
    exportButton: {
      csv: settings?.AllowCriticalEditsAdmin || false,
      pdf: false,
    },
    maxColumnSort: "all_columns",
    rowStyle: (rowData) => ({
      backgroundColor:
        selectedRow === rowData.tableData?.id ? "#EBE7FB" : "#FBFAFE",
      borderBottom: "1px solid #EDE8F7",
      fontFamily: FONT,
    }),
    maxBodyHeight: "calc(100vh - 320px)",
    headerStyle: {
      position: "sticky",
      top: "0px",
      backgroundColor: "#EBE7FB",
      color: "#1A0F3B",
      fontWeight: 700,
      fontFamily: FONT,
      textAlign: "center",
      zIndex: 1,
      border: "1px solid #D7CFEB",
      padding: "12px 10px",
    },
    cellStyle: {
      border: "1px solid #EDE8F7",
      textAlign: "center",
      margin: "auto",
      fontFamily: FONT,
      color: "#221448",
      fontSize: "0.88em",
    },
    actionsColumnIndex: -1,
  };

  return bookinglistdata.loading ? (
    <CircularLoading />
  ) : (
    <Box sx={{ px: { xs: 0.5, sm: 1 }, pb: 3 }}>
      {/* Banner */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "18px",
          minHeight: { xs: 140, sm: 160 },
          mb: 2,
          backgroundImage: `linear-gradient(105deg, rgba(26,15,59,0.94) 0%, rgba(44,25,91,0.78) 42%, rgba(26,15,59,0.35) 100%), url(${driverBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "78% center",
          boxShadow: "0 12px 32px rgba(26,15,59,0.22)",
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 2.5 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ position: "relative", zIndex: 1, minWidth: 0, flex: 1 }}>
          <Typography
            sx={{
              fontFamily: FONT,
              fontWeight: 800,
              fontSize: { xs: "1.5rem", sm: "1.85rem" },
              color: "#FBFAFE",
              letterSpacing: "0.02em",
              mb: 0.75,
            }}
          >
            Conecta2
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap", mb: 1 }}>
            <Typography sx={{ fontFamily: FONT, fontSize: "0.9rem", color: "rgba(251,250,254,0.9)" }}>
              {t("sponsor_label") || "Patrocinador"}:{" "}
              <Box component="strong" sx={{ fontWeight: 700, color: "#FBFAFE" }}>
                {sponsorHeaderDisplay}
              </Box>
            </Typography>
            <Tooltip title={t("copy_link", { defaultValue: "Copiar" })}>
              <IconButton size="small" onClick={copySponsor} sx={{ color: "#FBFAFE", p: 0.4 }}>
                <ContentCopyIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("referrals_refresh_tooltip")}>
              <IconButton
                size="small"
                onClick={() => refreshReferralList()}
                sx={{ color: "#FBFAFE", p: 0.4 }}
              >
                <RefreshIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography
            sx={{
              fontFamily: FONT,
              fontSize: { xs: "0.78rem", sm: "0.85rem" },
              color: "rgba(251,250,254,0.82)",
              lineHeight: 1.4,
              maxWidth: 520,
            }}
          >
            {t("sponsor_or_master_hint") ||
              "Los usuarios referidos muestran el nombre de su patrocinador; si no tienen código de invitación, aparecen bajo CODIGO MASTER."}
          </Typography>
          {(myLevelLabel || mySlotsTotal != null) && (
            <Typography
              sx={{
                mt: 1,
                fontFamily: FONT,
                fontSize: "0.78rem",
                color: "rgba(251,250,254,0.75)",
              }}
            >
              {myLevelLabel ? `Rol red: ${myLevelLabel}` : null}
              {myLevelLabel && mySlotsTotal != null ? " · " : null}
              {mySlotsTotal != null
                ? `Cupos: ${api.formatDirectSlots(mySlotsUsed, mySlotsTotal)}`
                : null}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "flex-end",
            flexShrink: 0,
            pr: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: FONT,
              fontWeight: 700,
              fontSize: "0.85rem",
              color: "#FBFAFE",
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              textAlign: "right",
              lineHeight: 1.35,
            }}
          >
            Juntos llegamos
            <br />
            más lejos
          </Typography>
          <Box
            sx={{
              mt: 0.8,
              width: 48,
              height: 3,
              borderRadius: 2,
              background: "linear-gradient(90deg, #6411ED, #7628FF)",
            }}
          />
        </Box>
      </Box>

      {/* Tabla de distribución — se conserva */}
      <Box
        sx={{
          mb: 2,
          p: { xs: 2, sm: 2.5 },
          borderRadius: "16px",
          backgroundColor: "#FBFAFE",
          border: "1px solid #D7CFEB",
          boxShadow: "0 8px 24px rgba(26,15,59,0.06)",
        }}
      >
        <Typography
          sx={{
            fontFamily: FONT,
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1A0F3B",
            mb: 1.5,
          }}
        >
          Distribución del 16% destinado a la red
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.25,
            alignItems: "center",
            mb: 1.5,
          }}
        >
          {[1, 2, 3].map((lvl) => (
            <Box
              key={lvl}
              sx={{
                px: 1.5,
                py: 0.75,
                borderRadius: "10px",
                backgroundColor: "#EBE7FB",
                border: "1px solid #D7CFEB",
                fontFamily: FONT,
                fontSize: "0.88rem",
                color: "#221448",
              }}
            >
              Nivel {lvl}:{" "}
              <Box component="strong" sx={{ color: "#6411ED", fontWeight: 800 }}>
                {api.NETWORK_LEVEL_PERCENTS?.[lvl] ?? (lvl === 1 ? 8 : lvl === 2 ? 6 : 2)}%
              </Box>
            </Box>
          ))}
          <Box
            sx={{
              px: 1.75,
              py: 0.75,
              borderRadius: "10px",
              background: "linear-gradient(90deg, #6411ED 0%, #7628FF 100%)",
              color: "#FBFAFE",
              fontFamily: FONT,
              fontWeight: 700,
              fontSize: "0.88rem",
              boxShadow: "0 4px 12px rgba(100,17,237,0.28)",
            }}
          >
            {api.NETWORK_DISTRIBUTION_LABEL || "8% / 6% / 2% = 16%"}
          </Box>
        </Box>
        {(() => {
          const uid = auth.profile?.uid;
          const isLeader = api.isLeaderDriver ? api.isLeaderDriver(auth.profile, uid) : false;
          const monthlyCap = api.resolveEarningsCap
            ? api.resolveEarningsCap(auth.profile, uid)
            : isLeader ? 50000000 : 30000000;
          const paydayCap = api.getPaydayWithdrawCap
            ? api.getPaydayWithdrawCap(auth.profile, uid)
            : Math.floor(monthlyCap / 2);
          const paydays = api.formatWithdrawPaydays
            ? api.formatWithdrawPaydays()
            : (api.WITHDRAW_PAYDAYS || [15, 30]).join(" y ");
          const fmt = (n) => (api.formatCop ? api.formatCop(n) : n);
          return (
            <>
              <Typography sx={{ fontFamily: FONT, fontSize: "0.85rem", color: "#766293", mb: 0.5 }}>
                Tu techo mensual de cobro{isLeader ? " como líder" : ""}:{" "}
                <Box component="strong" sx={{ color: "#1A0F3B" }}>
                  {fmt(monthlyCap)}
                </Box>
              </Typography>
              <Typography sx={{ fontFamily: FONT, fontSize: "0.8rem", color: "#766293" }}>
                Retiros los días {paydays}: hasta{" "}
                <Box component="strong" sx={{ color: "#1A0F3B" }}>
                  {fmt(paydayCap)}
                </Box>{" "}
                cada día · mínimo {fmt(api.MIN_REFERRAL_WITHDRAW || 100000)} · fee de plataforma{" "}
                {api.REFERRAL_WITHDRAW_FEE_PERCENT || 5}%
              </Typography>
            </>
          );
        })()}
      </Box>

      {/* Level cards */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {levelCards.map((card) => (
          <Grid item xs={12} sm={4} key={card.n}>
            <Tooltip title={card.hint}>
              <Box
                component="button"
                type="button"
                onClick={() => btn_level(card.n)}
                sx={{
                  width: "100%",
                  border: card.active ? "none" : "1px solid #D7CFEB",
                  borderRadius: "16px",
                  cursor: "pointer",
                  textAlign: "left",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  background: card.active
                    ? "linear-gradient(135deg, #6411ED 0%, #7628FF 100%)"
                    : "#FBFAFE",
                  boxShadow: card.active
                    ? "0 8px 22px rgba(100,17,237,0.32)"
                    : "0 4px 14px rgba(26,15,59,0.06)",
                  transition: "transform 0.15s, box-shadow 0.15s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: card.active
                      ? "0 10px 26px rgba(100,17,237,0.4)"
                      : "0 6px 18px rgba(26,15,59,0.1)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: card.active
                      ? "rgba(251,250,254,0.18)"
                      : "#EBE7FB",
                    flexShrink: 0,
                  }}
                >
                  <GroupsOutlinedIcon
                    sx={{ color: card.active ? "#FBFAFE" : "#6411ED", fontSize: 26 }}
                  />
                </Box>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      letterSpacing: "0.08em",
                      color: card.active ? "rgba(251,250,254,0.9)" : "#766293",
                      textTransform: "uppercase",
                    }}
                  >
                    {card.label}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 800,
                      fontSize: "1.75rem",
                      color: card.active ? "#FBFAFE" : "#1A0F3B",
                      lineHeight: 1.1,
                    }}
                  >
                    {referralCountBadge(card.count)}
                  </Typography>
                </Box>
              </Box>
            </Tooltip>
          </Grid>
        ))}
      </Grid>

      {/* Table */}
      <Box
        sx={{
          backgroundColor: "#FBFAFE",
          borderRadius: "16px",
          border: "1px solid #D7CFEB",
          boxShadow: "0 8px 24px rgba(26,15,59,0.06)",
          overflow: "hidden",
          p: { xs: 1, sm: 1.5 },
        }}
      >
        <MaterialTable
          title=""
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "12px",
            boxShadow: "none",
            backgroundColor: "transparent",
          }}
          columns={columns}
          data={enrichedData}
          onRowClick={(evt, selectedRow) => lista_referral(selectedRow)}
          components={{
            Toolbar: (toolbarProps) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  width: "100%",
                  px: 0.5,
                  mb: 0.5,
                  "& .MuiToolbar-root": {
                    minHeight: 52,
                    paddingLeft: "0 !important",
                    paddingRight: "0 !important",
                    flex: "1 1 auto",
                    justifyContent: "flex-end",
                  },
                  "& .MuiIconButton-root": {
                    color: "#6411ED",
                    border: "1px solid #D7CFEB",
                    borderRadius: "10px",
                    width: 40,
                    height: 40,
                    backgroundColor: "#FBFAFE",
                    "&:hover": { backgroundColor: "#EBE7FB" },
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                  <GroupsOutlinedIcon sx={{ color: "#6411ED", fontSize: 22 }} />
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 800,
                      fontSize: { xs: "0.95rem", sm: "1.05rem" },
                      color: "#1A0F3B",
                    }}
                  >
                    {t("My_Referrals") || "Mis Referidos"} {level} ({enrichedData.length})
                  </Typography>
                </Box>
                <MTableToolbar {...toolbarProps} />
              </Box>
            ),
          }}
          options={tableOptions}
          localization={{
            body: {
              emptyDataSourceMessage: t("no_referrals_yet"),
            },
            toolbar: {
              searchPlaceholder:
                t("search_referrals_placeholder", {
                  defaultValue: "Buscar por nombre, email o teléfono...",
                }) || t("search"),
              exportTitle: t("export"),
              exportCSVName: t("export"),
            },
            header: {
              actions: t("actions"),
            },
            pagination: {
              labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
              firstTooltip: t("first_page_tooltip"),
              previousTooltip: t("previous_page_tooltip"),
              nextTooltip: t("next_page_tooltip"),
              lastTooltip: t("last_page_tooltip"),
            },
          }}
        />
      </Box>

      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </Box>
  );
};

export default BookingHistory;
